<script setup>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import WaterLineChart from '@/components/water-line/WaterLineChart.vue'

const store = useStore()

const waterLineChart = ref(null)

const currentStabSchematisationStage = computed(
  () => store.state.stabSchematisationStage.currentItem
)

const topoPlotData = computed(() => store.getters['topoProfilePoint/getPlotData'])
const soilLayerPlotData = computed(() => store.getters['soilLayer/getPlotData'])
const phreaticLinePlotData = computed(() => store.getters['phreaticLine/getPlotData'])
const phreaticReferenceLinePlotData = computed(
  () => store.getters['phreaticReferenceLine/getPlotData']
)
const refPlot = computed(() => `phreatic-line-${currentStabSchematisationStage.value.id}`)

const phreaticLineCombinePlotData = computed(() => [
  ...soilLayerPlotData.value(),
  ...topoPlotData.value(),
  ...phreaticLinePlotData.value(),
  ...phreaticReferenceLinePlotData.value()
])

const emit = defineEmits(['clickPoint'])

defineExpose({
  waterLineChart
})
</script>
<template>
  <WaterLineChart
    :data-chart="phreaticLineCombinePlotData"
    :refPlot="refPlot"
    ref="waterLineChart"
    @clickPoint="(e) => emit('clickPoint', e)"
  ></WaterLineChart>
</template>
